import { useMemo, useState } from 'react';

import { ChatBox } from './ChatBox';
import { InfoContent } from './InfoContent';

import { Button, Card, Modal } from '@/components';
import useTourney from '@/hooks/useTourney';
import {
  DatosParticipanteMiniLigasTO,
  ResponseVerML,
} from '@/types/minileagues';

export const SidebarContentView = () => {
  const { tourneyData } = useTourney();
  const [showModalInfo, setShowModalInfo] = useState(false);

  const minileague: DatosParticipanteMiniLigasTO[] = useMemo(() => {
    const viewMl = tourneyData.tourney as ResponseVerML;
    return viewMl.miniliga?.partis || [];
  }, [tourneyData.tourney]);

  const users =
    minileague?.map((element: DatosParticipanteMiniLigasTO) => ({
      id: String(element.part?.idUsuario),
      display: `${element.part?.n} ${element.part?.a}`,
    })) ?? [];

  return (
    <>
      <div className="lg:w-[426px]">
        <div className="max-h-[101px] h-screen" />
        <Card className="p-0 bg-white w-full rounded-[8px]">
          <ChatBox users={users} />
        </Card>
        <Button
          className="mt-8 mx-auto flex justify-center items-center font-bold"
          type="button"
          variant="text"
          onClick={() => {
            setShowModalInfo(true);
          }}
        >
          Más información y Premios
        </Button>
      </div>
      {/* MODAL INFO */}
      <Modal
        className="w-[500px] text-center px-[38px]"
        controlledOnClose={() => setShowModalInfo(false)}
        isControlledOpen={Boolean(showModalInfo)}
        render={() => <InfoContent />}
        size="sm"
        variant="controlled"
      />
    </>
  );
};
